"use client";

import { c as _c } from "react/compiler-runtime";
import { Carousel, type CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@repo/design-system/components/ui/carousel";
import { cn } from "@repo/design-system/utils/cn";
import { useEffect, useMemo, useState } from "react";
import ChevronLeft from "~/components/icons/chevron-left-eon";
import ChevronRight from "~/components/icons/chevron-right-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import YouTubePlayer from "../jobadvideo/youtube-eon";
interface VideoConfig {
  headline: string;
  text: string;
  thumbnailSrc?: string;
  videoId: string;
}
const MUNICH_LOCATION_VARIANTS = ["München", "Munich", "Mnichov"] as const;
function VideoContent(t0) {
  const $ = _c(13);
  const {
    video
  } = t0;
  let t1;
  if ($[0] !== video.headline) {
    t1 = <h2 className="mb-5 font-bold text-4xl text-primary" data-source="lc">{video.headline}</h2>;
    $[0] = video.headline;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== video.text) {
    t2 = <p className="text-foreground text-lg" data-source="lc">{video.text}</p>;
    $[2] = video.text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex max-w-[500px] flex-grow flex-col justify-center justify-self-end lg:max-w-[250px] lg:self-end lg:text-right">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== video.thumbnailSrc || $[8] !== video.videoId) {
    t4 = <YouTubePlayer className="mt-auto" thumbnailSrc={video.thumbnailSrc} videoId={video.videoId} />;
    $[7] = video.thumbnailSrc;
    $[8] = video.videoId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export default function LocationVideo(t0) {
  const $ = _c(38);
  const {
    job
  } = t0;
  const t = useLanguage();
  const locale = (t.i18n === "de" ? "de" : "en") as "de" | "en";
  const [api, setApi] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  let t1;
  if ($[0] !== t.location_video_essen_HL || $[1] !== t.location_video_essen_text) {
    t1 = {
      videoId: "m3fh2E9UvPg",
      headline: t.location_video_essen_HL,
      text: t.location_video_essen_text,
      thumbnailSrc: "images/jobad/reports/EON_EDG_010_Campus Tour.jpg"
    };
    $[0] = t.location_video_essen_HL;
    $[1] = t.location_video_essen_text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const videoEssen = t1;
  const t2 = locale === "de" ? "pu2uOh67yu8" : "jpZI4schMA4";
  let t3;
  if ($[3] !== t.location_video_munich_HL || $[4] !== t.location_video_munich_text || $[5] !== t2) {
    t3 = {
      videoId: t2,
      headline: t.location_video_munich_HL,
      text: t.location_video_munich_text
    };
    $[3] = t.location_video_munich_HL;
    $[4] = t.location_video_munich_text;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const videoMunich = t3;
  let t4;
  if ($[7] !== job.data.locations || $[8] !== videoEssen || $[9] !== videoMunich) {
    bb0: {
      const locations = job.data.locations?.map(_temp) ?? [];
      const hasMunich = locations.some(_temp2);
      if (locations.includes("Essen") && hasMunich) {
        let t5;
        if ($[11] !== videoEssen || $[12] !== videoMunich) {
          t5 = [videoEssen, videoMunich];
          $[11] = videoEssen;
          $[12] = videoMunich;
          $[13] = t5;
        } else {
          t5 = $[13];
        }
        t4 = t5;
        break bb0;
      }
      if (locations.includes("Essen")) {
        let t5;
        if ($[14] !== videoEssen) {
          t5 = [videoEssen];
          $[14] = videoEssen;
          $[15] = t5;
        } else {
          t5 = $[15];
        }
        t4 = t5;
        break bb0;
      }
      if (hasMunich) {
        let t5;
        if ($[16] !== videoMunich) {
          t5 = [videoMunich];
          $[16] = videoMunich;
          $[17] = t5;
        } else {
          t5 = $[17];
        }
        t4 = t5;
        break bb0;
      }
      let t5;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[18] = t5;
      } else {
        t5 = $[18];
      }
      t4 = t5;
    }
    $[7] = job.data.locations;
    $[8] = videoEssen;
    $[9] = videoMunich;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const videos = t4;
  let t5;
  let t6;
  if ($[19] !== api) {
    t5 = () => {
      if (!api) {
        return;
      }
      const updateIndex = () => setCurrentIndex(api.selectedScrollSnap());
      updateIndex();
      api.on("select", updateIndex);
      return () => {
        api.off("select", updateIndex);
      };
    };
    t6 = [api];
    $[19] = api;
    $[20] = t5;
    $[21] = t6;
  } else {
    t5 = $[20];
    t6 = $[21];
  }
  useEffect(t5, t6);
  if (videos.length === 0) {
    return null;
  }
  if (videos.length === 1) {
    let t7;
    if ($[22] !== videos[0]) {
      t7 = <div className="w-full px-6 pb-10 md:px-10 md:pb-20 print:hidden"><div className="relative mx-auto flex w-full max-w-screen-xl auto-cols-[2fr_3fr] flex-col gap-8 lg:grid lg:grid-flow-col"><VideoContent video={videos[0]} /></div></div>;
      $[22] = videos[0];
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    return t7;
  }
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      align: "start",
      loop: true
    };
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== videos) {
    t8 = <CarouselContent>{videos.map(_temp3)}</CarouselContent>;
    $[25] = videos;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CarouselPrevious aria-label="Previous Video" className="relative inset-auto translate-x-0 translate-y-0 text-primary" icon={<ChevronLeft />} />;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== api || $[29] !== currentIndex || $[30] !== videos) {
    t10 = <div className="flex items-center gap-2">{videos.map((video_0, index) => <button aria-label={`Go to video ${index + 1} of ${videos.length}`} className="group flex size-6 items-center justify-center" key={video_0.videoId} onClick={() => api?.scrollTo(index)} type="button"><span className={cn("size-3 rounded-full border border-primary transition-colors", currentIndex === index ? "bg-primary" : "bg-white group-hover:bg-primary/20")} /></button>)}</div>;
    $[28] = api;
    $[29] = currentIndex;
    $[30] = videos;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CarouselNext aria-label="Next Video" className="relative inset-auto translate-x-0 translate-y-0 text-primary" icon={<ChevronRight />} />;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10) {
    t12 = <div className="mt-6 flex items-center justify-center gap-4">{t9}{t10}{t11}</div>;
    $[33] = t10;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t8) {
    t13 = <div className="w-full px-6 pb-10 md:px-10 md:pb-20 print:hidden"><Carousel className="relative mx-auto w-full max-w-screen-xl" opts={t7} setApi={setApi}>{t8}{t12}</Carousel></div>;
    $[35] = t12;
    $[36] = t8;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
}
function _temp3(video) {
  return <CarouselItem className="flex auto-cols-[2fr_3fr] flex-col gap-8 lg:grid lg:grid-flow-col" key={video.videoId}><VideoContent video={video} /></CarouselItem>;
}
function _temp2(city) {
  return MUNICH_LOCATION_VARIANTS.includes(city as (typeof MUNICH_LOCATION_VARIANTS)[number]);
}
function _temp(loc) {
  return loc.city;
}